import { request } from "store/api/customerGet/customerGetActions";
import { useResource } from "./useResource";
import { hasAccess, resources, access } from "@p81-common/shell-core-js";

export function useCustomer() {
  return useResource(
    "customerGet",
    request,
    hasAccess(resources.BILLING, access.READ)
  );
}
